import React from "react";
import { makeStyles } from "@material-ui/core/styles";

import Parser from "html-react-parser";
import { BiCalendarCheck } from "@react-icons/all-files/bi/BiCalendarCheck";
import { MdMessage } from "@react-icons/all-files/md/MdMessage";

import { Box, Typography } from "@material-ui/core";
import Moment from "react-moment";
import "moment/locale/zh-cn";
import "moment/locale/th";
import "moment/locale/id";
import "moment/locale/es";
import "moment/locale/pt";

import CommentController from "./comment/comment-controller";
import { getLocaleValueFromArrayByName } from "../../../../../helpers/get-locale-value-from-array-by-name";
import Skeleton from "@material-ui/lab/Skeleton";

const useStyles = makeStyles({
  wrapper: {
    borderBottom: "1px solid #ddd",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
  },

  bold: {
    fontWeight: "bold",
  },

  userInfo: {
    width: "100%",
    display: "flex",
    alignItems: "center",
  },

  commentWrapper: {
    border: "1px dashed #ddd",
    backgroundColor: "#fafafa",
  },

  avatarImage: {
    width: "70px",
    height: "70px",
    border: "3px solid #efefef",
    flexShrink: "0",
  },
});

const ForumItemViewPhone = ({
  locale,
  data,
  isCommentLoading,
  comments,
  location,
  copywritingVariants,
}) => {
  const { posttime, username, avatarurl, commentcount } = data.post;
  const classes = useStyles();

  let message_html = data.post.message_html;
  message_html = message_html.replaceAll(
    '"filedata/fetch?id=',
    "http://forum.ragnaroketernallove.com/filedata/fetch?id="
  );

  //since the timestamp returned is missing the last 3 digits, the miliseconds of the time, we just append it in to get the correct time stamp
  const postDate = new Date(parseInt(posttime + "000"));

  return (
    <Box mt={0}>
      <Box px={1}>
        <Box className={classes.wrapper} py={2}>
          <Box className={classes.userInfo}>
            <img
              className={classes.avatarImage}
              src={`https://forum.ragnaroketernallove.com/${avatarurl}`}
            />
            <Box ml={1} display="flex" flexDirection="column">
              <Typography className={`text-secondary ${classes.bold}`}>
                {username}
              </Typography>

              <Box
                mt={1}
                display="flex"
                alignItems="center"
                justifyContent="flex-end"
                color="#6d6d6d"
                fontStyle="italics"
                fontSize="0.85em"
              >
                <Box color="#a9a9a9" fontSize="1.2em" lineHeight="1em">
                  <BiCalendarCheck />
                </Box>

                <Box ml={0.5} mt={-0.15}>
                  <Moment
                    locale={locale}
                    format="DD MMM YY, hh:mm A"
                    date={postDate}
                  />
                </Box>
              </Box>
              {/* <Typography variant="body2" className={`${classes.bold}`}>
                {user.member_status}
              </Typography>
              <Box mt={5} fontSize="0.8em">
                <Box>
                  Join Date:{" "}
                  <Moment
                    locale={locale}
                    format="MMMM YYYY"
                    date={user.join_date}
                  />
                </Box>
                <Box>Posts: {user.post_count}</Box>
              </Box> */}
            </Box>
          </Box>

          <Box width="100%">
            <Box mt={1} fontSize="0.8em">
              <Box pt={1}>
                <Box>{Parser(message_html)}</Box>
              </Box>

              {parseInt(commentcount) > 0 && (
                <Box mt={2}>
                  <Box p={1} className={classes.commentWrapper}>
                    <Box display="flex" alignItems="center" color="#777">
                      <MdMessage />
                      <Box ml={0.5} mt={0.15} fontStyle="normal">
                        {copywritingVariants &&
                          getLocaleValueFromArrayByName(
                            locale,
                            copywritingVariants,
                            "copywriting-comments"
                          ).content}{" "}
                      </Box>
                    </Box>

                    {isCommentLoading ? (
                      <Box
                        border="1px solid #eee"
                        style={{ background: "#fff" }}
                        p={2}
                        mt={1}
                      >
                        <Box display="flex">
                          <Box flexShrink="0">
                            <Skeleton variant="rect" width={50} height={50} />
                          </Box>

                          <Box width="100%" ml={2}>
                            <Skeleton />
                            <Skeleton />
                          </Box>
                        </Box>
                        <Box mt={3} display="flex">
                          <Box flexShrink="0">
                            <Skeleton variant="rect" width={50} height={50} />
                          </Box>

                          <Box width="100%" ml={2}>
                            <Skeleton />
                            <Skeleton />
                          </Box>
                        </Box>
                      </Box>
                    ) : (
                      <Box>
                        {comments?.map((n, i) => (
                          <CommentController
                            key={i}
                            data={n}
                            location={location}
                          />
                        ))}
                      </Box>
                    )}
                  </Box>
                </Box>
              )}
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
export default ForumItemViewPhone;
